import { takeEvery, put, call } from "redux-saga/effects";

// Chat Redux States
import {
  GET_CHATS,
  GET_CHATS_REQUEST,
  GET_CONTACTS,
  GET_GROUPS,
  GET_MESSAGES,
  GET_MESSAGES_REQUEST,
  POST_ADD_MESSAGE,
  POST_ADD_MESSAGE_REQUEST,
} from "./actionTypes";
import {
  getChatsSuccess,
  getChatsFail,
  getGroupsSuccess,
  getGroupsFail,
  getContactsSuccess,
  getContactsFail,
  getMessagesSuccess,
  getMessagesFail,
  addMessageSuccess,
  addMessageFail,
  getChatPollingSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getChats,
  getGroups,
  getContacts,
  getMessages,
  addMessage,
  getChatPolling,
} from "../../helpers/fakebackend_helper";

function* onGetChats() {
  try {
    yield put({ type: GET_CHATS_REQUEST });
    
    const response = yield call(getChats);
    const transformedResponse = response.users.map(user => ({
      id: user.id,  
      name: user.name,
      status: "offline", 
      roomId: user.roomId, 
      description: "No description available", 
      time: "11:00 AM",  
      image: "default_avatar"  
    }));
    
    yield put(getChatsSuccess(transformedResponse));
  } catch (error) {
    yield put(getChatsFail(error));
  }
}

function* onGetGroups() {
  try {
    // const response = yield call(getGroups);
    const response = []
    yield put(getGroupsSuccess(response));
  } catch (error) {
    yield put(getGroupsFail(error));
  }
}

function* onGetContacts() {
  try {
    // const response = yield call(getContacts);
    const response = []
    yield put(getContactsSuccess(response));
  } catch (error) {
    yield put(getContactsFail(error));
  }
}

function* onGetMessages({ roomId }) {
  try {
    yield put({ type: GET_MESSAGES_REQUEST });
    const response = yield call(getMessages, roomId);
    const transformedResponse = response?.messages?.map(message => ({
      id: message.id,
      roomId: message.room_id,
      sender: message.sender_name,
      sender_id: message.sender_id,
      receiver_id: message.receiver_id,
      message: message.message,
      is_read: message.is_read,
      created_at: new Date(message.created_at),
    }));

    // const response = [
    //   { id: 1, roomId: 2, sender: "Alice", message: "Hello, how are you?", createdAt: new Date() },
    //   { id: 2, roomId: 2, sender: "You", message: "I'm good, thanks. How about you?", createdAt: new Date() },
    //   { id: 3, roomId: 2, sender: "Bob", message: "I'm doing great, thanks for asking.", createdAt: new Date() },
    //   { id: 4, roomId: 3, sender: "Charlie", message: "room 3 message", createdAt: new Date() },
    //   { id: 5, roomId: 1, sender: "Alice", message: "I'm 1 thinking of going to the park.", createdAt: new Date() },
    //   { id: 5, roomId: 1, sender: "Alice", message: "I'm 2 thinking of going to the park.", createdAt: new Date() },
    //   { id: 6, roomId: 1, sender: "You", message: "Sounds like fun. Can I join you?", createdAt: new Date() },
    //   { id: 7, roomId: 1, sender: "Bob", message: "I'd love to come too.", createdAt: new Date() },
    //   { id: 8, roomId: 1, sender: "Charlie", message: "Me too. What time were you thinking?", createdAt: new Date() },
    // ] 
    // const filteredResponse = response.filter(message => message.roomId === roomId);
    yield put(getMessagesSuccess(transformedResponse));
  } catch (error) {
    yield put(getMessagesFail(error));
  }
}

function* onAddMessage({ message }) {
  try {
    yield put({ type: POST_ADD_MESSAGE_REQUEST });
    const response = yield call(addMessage, message);
    // const response = [ 
    //   { id: 34, roomId: 1, sender: "Bob", message: "I'd love to come too.", createdAt: new Date() },
    //   { id: 65, roomId: 1, sender: "Charlie", message: "Me too. What time were you thinking?", createdAt: new Date() },
    // ]

    const transformedResponse = response?.message_data?.map(msg => ({
      id: msg.id,
      roomId: msg.room_id,  
      sender: msg.sender_name, 
      sender_id: msg.sender_id,  
      receiver_id: msg.receiver_id, 
      message: msg.message,
      createdAt: new Date(msg.created_at), 
    }));
    yield put(addMessageSuccess(transformedResponse));
  } catch (error) {
    yield put(addMessageFail(error));
  }
}



function* onGetChatPolling() {
  try {
    const response = yield call(getChatPolling);
    console.log('response', response)
    yield put(getChatPollingSuccess(response));
    return response
  } catch (error) {
    yield put(getChatPollingFail(error));
  }
}

function* chatSaga() {
  yield takeEvery(GET_CHATS, onGetChats);
  yield takeEvery(GET_GROUPS, onGetGroups);
  yield takeEvery(GET_CONTACTS, onGetContacts);
  yield takeEvery(GET_MESSAGES, onGetMessages);
  yield takeEvery(POST_ADD_MESSAGE, onAddMessage);
}

export default chatSaga;
